import baseRequest from './baseRequest';
import * as _ from 'lodash';
import * as cookie from 'react-cookie';
import * as formPostUtils from './formPost';

const OAUTH_TRANSACTION_URL = '/auth/oauth/authorize';

export async function oAuthTransaction() {
  return await baseRequest.get(OAUTH_TRANSACTION_URL);
}

interface FormLogoutParams {
  message: string;
}

export function formLogout(params?: FormLogoutParams) {
  // objectToFormData will clear out undefined values -- we want to submit this input even if it is not defined
  const csrfToken = cookie.load('XSRF-TOKEN') || '';
  formPostUtils.formPost('/api/session/logout', _.extend({ _csrf: csrfToken }, params));
}
